import {
  GetStoriesByCompanyIdMeta,
  GetStoriesByCompanyIdPayload,
} from 'types/store/GetStoriesByCompanyIdState';
import { createAsyncReducer } from 'utils/Redux';

import { getStoriesByCompanyIdActions } from '../actions';

export default createAsyncReducer<
  GetStoriesByCompanyIdMeta,
  GetStoriesByCompanyIdPayload
>(getStoriesByCompanyIdActions);
